import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantSelectorComponent } from './tenant-selector/tenant-selector.component';
import {NzAvatarModule} from "ng-zorro-antd/avatar";
import { DataSearchFormComponent } from './data-search-form/data-search-form.component';
import {NzFormModule} from "ng-zorro-antd/form";
import {NzInputModule} from "ng-zorro-antd/input";
import {FormsModule} from "@angular/forms";
import {NzDatePickerModule} from "ng-zorro-antd/date-picker";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzIconModule} from "ng-zorro-antd/icon";
import {TranslateModule} from "@ngx-translate/core";
import {NzSelectModule} from "ng-zorro-antd/select";
import {NzRadioModule} from "ng-zorro-antd/radio";
import {NzAutocompleteModule} from "ng-zorro-antd/auto-complete";
import { GenerateHtmlxlsxComponent } from './generate-htmlxlsx/generate-htmlxlsx.component';
import {BpmnToolsComponent } from './bpmn/customTools/bpmn-tools.component';
import {BrowserModule } from '@angular/platform-browser';


@NgModule({
  declarations: [
    TenantSelectorComponent,
    DataSearchFormComponent,
    GenerateHtmlxlsxComponent,
    BpmnToolsComponent
  ],
  exports: [
    TenantSelectorComponent,
    DataSearchFormComponent,
    GenerateHtmlxlsxComponent,
    BpmnToolsComponent
  ],
  imports: [
    CommonModule,
    NzAvatarModule,
    NzFormModule,
    NzInputModule,
    FormsModule,
    NzDatePickerModule,
    NzButtonModule,
    NzIconModule,
    TranslateModule,
    NzSelectModule,
    NzRadioModule,
    NzAutocompleteModule
  ]
})
export class ToolsModule { }
